const routes = [
  {
    path: `/DeviceManagement`,
    name: `DeviceManagement`,
    component: () => import(`@/views/DeviceManagement`),
    meta: {
      name: `设备管理`,
      icon: `icon-shebeiguanli`,
      inMenu: true,
    },
    children: [
      {
        path: `/DeviceMsg`,
        name: `DeviceMsg`,
        component: () => import(`@/views/DeviceManagement/DeviceMsg`),
        meta: {
          name: `设备信息`,
          keepAlive: true,
          inMenu: true,
        },
      },
      {
        path: `/DeviceOutInit`,
        name: `DeviceOutInit`,
        component: () => import(`@/views/DeviceManagement/DeviceOutInit`),
        meta: {
          name: `初始化外部设备`,
          inMenu: false,
        },
      },
      {
        path: `/DeviceOutManagement`,
        name: `DeviceOutManagement`,
        component: () => import(`@/views/DeviceManagement/DeviceOutManagement`),
        meta: {
          name: `外设管理`,
          inMenu: true,
        },
      },
      {
        path: `/DeployManagement`,
        name: `DeployManagement`,
        component: () => import(`@/views/DeviceManagement/DeployManagement`),
        meta: {
          name: `部署管理`,
          inMenu: false,
        },
      },
    ],
  },
  {
    path: `/BusinessDataManagement`,
    name: `BusinessDataManagement`,
    component: () => import(`@/views/BusinessDataManagement`),
    meta: {
      name: `业务数据管理`,
      icon: `icon-yewushujuguanli`,
      inMenu: true,
    },
    children: [
      {
        path: `/BusinessDataMonitor`,
        name: `BusinessDataMonitor`,
        component: () =>
          import(`@/views/BusinessDataManagement/BusinessDataMonitor`),
        meta: {
          name: `业务数据监控`,
          inMenu: true,
        },
      },
      {
        path: `/BusinessDataStatistics`,
        name: `BusinessDataStatistics`,
        component: () =>
          import(`@/views/BusinessDataManagement/BusinessDataStatistics`),
        meta: {
          name: `业务数据统计`,
          inMenu: true,
        },
      },
      {
        path: `/BusinessDataGroupStatistics`,
        name: `BusinessDataGroupStatistics`,
        component: () =>
          import(`@/views/BusinessDataManagement/BusinessDataGroupStatistics`),
        meta: {
          name: `企业分组统计`,
          inMenu: true,
        },
      },
      {
        path: `/BusinessDataSynchronization`,
        name: `BusinessDataSynchronization`,
        component: () =>
          import(`@/views/BusinessDataManagement/BusinessDataSynchronization`),
        meta: {
          name: `数据同步管理`,
          inMenu: true,
        },
      },
      {
        path: `/BusinessDataUploadRemedy`,
        name: `BusinessDataUploadRemedy`,
        component: () =>
          import(`@/views/BusinessDataManagement/BusinessDataUploadRemedy`),
        meta: {
          name: `上传补救策略`,
          inMenu: true,
        },
      }
    ],
  },
  {
    path: `/SeeLog`,
    name: `SeeLog`,
    component: () => import(`@/views/BusinessDataManagement/SeeLog`),
    meta: {
      name: `日志查看`,
      icon: `icon-rizhichakan`,
      inMenu: true,
    },
    children: [
      {
        path: `/SeeCloudLog`,
        name: `SeeCloudLog`,
        component: () =>
          import(`@/views/BusinessDataManagement/SeeLog/SeeCloudLog`),
        meta: {
          name: `云端日志查看`,
          inMenu: true,
        },
      },
      {
        path: `/CollectionLog`,
        name: `CollectionLog`,
        component: () =>
          import(`@/views/BusinessDataManagement/SeeLog/CollectionLog`),
        meta: {
          name: `采集端日志`,
          inMenu: true,
        },
      },
    ],
  },
  {
    path: `/ParamsSetAndSync`,
    name: `ParamsSetAndSync`,
    component: () => import(`@/views/ParamsSetAndSync`),
    meta: {
      name: `参数设置管理`,
      icon: `icon-canshushezhi`,
      inMenu: true,
    },
    children: [
      {
        path: `/HandleCodeParamsSetAndSync`,
        name: `HandleCodeParamsSetAndSync`,
        component: () =>
          import(`@/views/ParamsSetAndSync/HandleCodeParamsSetAndSync`),
        meta: {
          name: `参数设置与同步`,
          inMenu: true,
        },
      },
      {
        path: `/HistoryParameter`,
        name: `HistoryParameter`,
        component: () => import(`@/views/ParamsSetAndSync/HistoryParameter`),
        meta: {
          name: `历史参数`,
          inMenu: false,
        },
      },
    ],
  },
  {
    path: `/DeviceRunManagement`,
    name: `DeviceRunManagement`,
    component: () => import(`@/views/DeviceRunManagement`),
    meta: {
      name: `设备运行管理`,
      icon: `icon-shebeiyunxing`,
      inMenu: true,
    },
    children: [
      {
        path: `/DeviceStatusManagement`,
        name: `DeviceStatusManagement`,
        component: () =>
          import(`@/views/DeviceRunManagement/DeviceStatusManagement`),
        meta: {
          name: `设备状态管理`,
          inMenu: true,
          keepAlive: true,
        },
      },
      {
        path: `/ElectronicScaleThemeLibrary`,
        name: `ElectronicScaleThemeLibrary`,
        component: () =>
          import(`@/views/DeviceRunManagement/ElectronicScaleThemeLibrary`),
        meta: {
          name: `电子秤主题库`,
          inMenu: true,
        },
      },
      {
        path: `/SignManagementAndCheck`,
        name: `SignManagementAndCheck`,
        component: () =>
          import(`@/views/DeviceRunManagement/SignManagementAndCheck`),
        meta: {
          name: `卷标号管理与验证`,
          inMenu: false,
        },
      },
    ],
  },
  {
    path: `/CollectionSystemSetUpManagement`,
    name: `CollectionSystemSetUpManagement`,
    component: () => import(`@/views/CollectionSystemSetUpManagement`),
    meta: {
      name: `采集器系统升级管理`,
      icon: `icon-cjqxtsj`,
      inMenu: true,
    },
    children: [
      {
        path: `/UpdateManagement`,
        name: `UpdateManagement`,
        component: () =>
          import(`@/views/CollectionSystemSetUpManagement/UpdateManagement`),
        meta: {
          name: `升级管理`,
          inMenu: true,
        },
      },
      {
        path: `/ReleaseNameListSetUp`,
        name: `ReleaseNameListSetUp`,
        component: () =>
          import(
            `@/views/CollectionSystemSetUpManagement/ReleaseNameListSetUp`
          ),
        meta: {
          name: `发布名单设置`,
          inMenu: false,
        },
      },
      {
        path: `/UpdatedDeviceList`,
        name: `UpdatedDeviceList`,
        component: () =>
          import(`@/views/CollectionSystemSetUpManagement/UpdatedDeviceList`),
        meta: {
          name: `已升级设备列表`,
          inMenu: false,
        },
      },
      {
        path: `/UpgradeStatusList`,
        name: `UpgradeStatusList`,
        component: () =>
          import(`@/views/CollectionSystemSetUpManagement/UpgradeStatusList`),
        meta: {
          name: `设备升级状态列表`,
          inMenu: false,
        },
      },
    ],
  },
];

function handle(arr, keys) {
  const resArr = [];
  arr.forEach((item) => {
    if (keys.includes(item.name)) {
      const resItem = Object.assign({}, item);
      if (item.children) {
        resItem.children = handle(item.children, keys);
        if (!resItem.children.length) delete resItem.children;
        else resItem.redirect = resItem.children[0].path;
      }
      resArr.push(resItem);
    }
  });
  return resArr;
}
export const getRoutes = (keys) => {
  return [
    {
      path: `/Home`,
      name: `Home`,
      component: () => import(`../views/Home`),
      meta: {
        name: `首页`,
        icon: `icon-shouye`,
        inMenu: false,
      },
    },
    ...handle(routes, keys),
    {
      path: `/404`,
      name: `404`,
      meta: {
        inMenu: false,
        name: `暂无权限，请联系管理员`,
      },
      component: () => import(`../views/NotFind`),
    },
  ];
};
